import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../../../core/core.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// Datatable
import { DataTableComponent } from './general/data-table/data-table.component';
// General widgets
import { Widget1Component } from './widget1/widget1.component';
import { Widget5Component } from './widget5/widget5.component';
import { Timeline2Component } from './timeline2/timeline2.component';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { ReportProgressWidgetComponent } from './report-progress-widget/report-progress-widget.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
	declarations: [
		DataTableComponent,
		// Widgets
		Widget1Component,
		Widget5Component,
		Timeline2Component,
		ReportProgressWidgetComponent,
	],
	exports: [
		DataTableComponent,
		// Widgets
		Widget1Component,
		Widget5Component,
		Timeline2Component,
		ReportProgressWidgetComponent,
	],
	imports: [
		CommonModule,
		PerfectScrollbarModule,
		MatTableModule,
		CoreModule,
		MatIconModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		MatPaginatorModule,
		MatSortModule,
		MatProgressBarModule,
	]
})
export class WidgetModule {
}
